<div fxLayout="row" fxLayoutAlign="end center" class="consolidation-info">
    <div *ngIf="consolidationStatuses.length > 0" fxLayout="row" fxLayoutGap="20px">
        <span class="txt-s-14-4">{{ "Data situation" |i18n }}</span>
        <div *ngFor="let status of consolidationStatuses; trackBy trackByFn" fxLayout="row" fxLayoutGap="10px">
            <span class="txt-s-14-4">{{ status.month |i18n }}{{ ":" }}</span>
            <app-icon class="txt-s-16-4 consolidated-month" name="fal-check-circle"
                      *ngIf="status.consolidated"
                      [title]="'Consolidated data'|i18n">
            </app-icon>
            <app-icon class="txt-s-16-4 non-consolidated-month" name="fal-tachometer-alt-fast"
                      *ngIf="!status.consolidated"
                      [title]="'Non consolidated data'|i18n">
            </app-icon>
        </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-24 mb-16" *ngIf="consolidationStatuses.length ===0">
        <mat-spinner app-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{ 'Loading'|i18n }}...</span>
    </div>
</div>